const CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME || 'dxxwnygrp';

const EXTERNAL_URL_PATTERN = /^https?:\/\//;

const IMAGE_SIZES = {
  thumbnail: { w: 150, h: 150, crop: 'fill' },
  card: { w: 400, h: 300, crop: 'fill' },
  large: { w: 1200, h: 750, crop: 'fill' },
  original: null,
};

const FALLBACK_IMAGE = 'https://images.unsplash.com/photo-1558453975-d6c57ab62b20?q=80&w=1600';

export function getImageUrl(imageRef, size = 'card') {
  if (!imageRef) return FALLBACK_IMAGE;

  if (EXTERNAL_URL_PATTERN.test(imageRef)) return imageRef;  

  const cfg = IMAGE_SIZES[size];
  if (!cfg) {
    return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/q_auto,f_auto/${imageRef}`;
  }
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/w_${cfg.w},h_${cfg.h},c_${cfg.crop},q_auto,f_auto/${imageRef}`;
}
